<footer class="footer fixed-bottom bg-dark-elevated-1 text-muted">
  <p class="footer-text">
    <a class="link-text" href="https://github.com/aritchie05/EcoCraftingTool"
       rel="noopener noreferrer" target="_blank">
      {{message('sourceCodeLink')}}
    </a> |
    <a class="link-text" href="https://github.com/aritchie05/EcoCraftingTool/issues"
       rel="noopener noreferrer" target="_blank">
      {{message('feedbackLink')}}
    </a> |
    <a class="link-text" href="https://github.com/aritchie05"
       rel="noopener noreferrer" target="_blank">
      {{message('authorLink')}}
    </a> |
    <a class="link-text" href="http://public.identityworks.ru/Eco/Calc/"
       rel="noopener noreferrer" target="_blank">
      {{message('creditLink')}}
    </a>
  </p>
</footer>
